import { Record } from 'immutable';
import {
  MOBILE_NUMBER_VALID,
  RESTART_LOGIN_PROCESS,
  CLEAR_MOBILE_NUMBER
} from './actions';

const InitialState = new Record({
  mobileNumber: '',
});

export default (state = new InitialState(), action) => {
  const { type } = action;

  switch (type) {
    case MOBILE_NUMBER_VALID: {
      const { mobileNumber } = action;

      return state.merge({
        mobileNumber
      });
    }
    case CLEAR_MOBILE_NUMBER:
    case RESTART_LOGIN_PROCESS: {
      return state.merge({
        mobileNumber: '',
      });
    }
    default: {
      return state;
    }
  }
};
